import React from 'react'
import { Row } from 'react-bootstrap'

import CanjesList from './CanjesList'
import { useColocacionEditContext } from 'features/Colocacion/ColocacionViewContext'
import { ColocacionSectionCard } from '../../ColocacionSectionCard'

import { AddIcon } from 'components/BymaIcons'

import { ColocacionSummary } from 'features/Colocacion/ColocacionSummary'
import { Loading } from 'components'
import { LocalErrorProvider } from 'core'

const CanjesSection = () => {
  const props = useColocacionEditContext()

  return (
    <ColocacionSectionCard title='Agregar Canje' icon={AddIcon}>
      <Row className='mb-3'>
        <ColocacionSummary {...props} showTitulo={true} />
      </Row>
      <Row className='p-0'>
        <Loading>
          <LocalErrorProvider>
            <CanjesList {...props} />
          </LocalErrorProvider>
        </Loading>
      </Row>
    </ColocacionSectionCard>
  )
}

export default CanjesSection
